import { Route, Routes, Navigate, useLocation } from 'react-router-dom';

import GamePage from './pages/GamePage';
import SplashScreen from './pages/SplashScreen';
import RoomsPage from './pages/RoomsPage';
import DecksPage from './pages/DecksPage';
import DeckEditorPage from './pages/DeckEditorPage';
import ShadersDemoPage from './pages/ShadersDemoPage';
import ParticlesDemoPage from './pages/ParticlesDemoPage';
import AttackAnimationPage from './pages/AttackAnimationPage';
import SpriteSheetDemoPage from './pages/SpriteSheetDemoPage';
import VsScreenDemoPage from './pages/VsScreenDemoPage';
import PackOpenDemoPage from './pages/PackOpenDemoPage';
import RangeSliderDemoPage from './pages/RangeSliderDemoPage';
import AnimationEditorPage from './pages/AnimationEditorPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import EffectsEditorPage from './pages/EffectsEditorPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import LobbyPage from './pages/LobbyPage';
import ShopPage from './pages/ShopPage';
import CollectionPage from './pages/CollectionPage';

import { useAuth } from './services/auth/authProvider';

function App() {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();
  const location = useLocation();

  return (
    <div className="App">
        <Routes>
          <Route path="/" element={<SplashScreen />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          { !isLoading && isAuthenticated && <Route path="/rooms" element={<RoomsPage />} /> }
          { !isLoading && isAuthenticated && <Route path="/decks/create" element={<DeckEditorPage mode="create" />} /> }
          { !isLoading && isAuthenticated && <Route path="/decks/edit/:deckId" element={<DeckEditorPage mode="edit" />} /> }
          { !isLoading && isAuthenticated && (
            <Route
              path="/game/:roomId"
              element={
                <GamePage
                  key={`${location.pathname}${location.search}:${location.state?.gameRemountKey ?? 0}`}
                />
              }
            />
          )}
          { !isLoading && isAuthenticated && <Route path="/lobby" element={<LobbyPage />} /> }
          { !isLoading && isAuthenticated && <Route path="/shop" element={<ShopPage />} /> }
          { !isLoading && isAuthenticated && <Route path="/collection" element={<CollectionPage />} /> }
          { !isLoading && isAuthenticated && isAdmin && <Route path="/admin" element={<AdminDashboardPage />} /> }
          { !isLoading && isAuthenticated && isAdmin && <Route path="/effects-editor" element={<EffectsEditorPage />} /> }
          <Route path="/shaders-demo" element={<ShadersDemoPage />} />
          <Route path="/particles-demo" element={<ParticlesDemoPage />} />
          <Route path="/attack-animation" element={<AttackAnimationPage />} />
          <Route path="/sprite-sheet-demo" element={<SpriteSheetDemoPage />} />
          <Route path="/vs-screen-demo" element={<VsScreenDemoPage />} />
          <Route path="/pack-open-demo" element={<PackOpenDemoPage />} />
          <Route path="/range-slider-demo" element={<RangeSliderDemoPage />} />
          <Route path="/animation-editor" element={<AnimationEditorPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    </div>
  );
}

export default App;
